import Content from "./content";
import { deferPromise } from "~/util/general";
import { CONFIG } from "~/config";
import { node } from "~/util/dom";

const SIZE = [400, 225];
const API_URL = `https://api.mapy.${CONFIG.TLDCZ}`;
const API_STATIC_URL = `${API_URL}/szn/v1/static/map`;

export default class Map extends Content {
	_promiseData: ReturnType<typeof deferPromise>;

	constructor(data, options) {
		super(data, options);

		this._promiseData = deferPromise();
		this._build2();
	}

	getPosterData() {
		return this._promiseData.promise;
	}

	/* eslint-disable-next-line */
	getContainer(): HTMLDivElement {
		return node("div", { style: "display: none" });
	}

	_build2() {
		const mapContainer = node("div");

		mapContainer.classList.add("content-map");
		mapContainer.style.width = `${SIZE[0]}px`;
		mapContainer.style.height = `${SIZE[1]}px`;

		const mapImg = new Image();
		const url = new URL(API_STATIC_URL);
		const mapset = this._data.source === "bs"
			? "winter"
			: "basic";

		url.searchParams.append("apiKey", CONFIG.mapiKey);
		url.searchParams.append("width", SIZE[0].toString());
		url.searchParams.append("height", SIZE[1].toString());
		url.searchParams.append("lon", this._data.center.x.toString());
		url.searchParams.append("lat", this._data.center.y.toString());
		url.searchParams.append("zoom", "14");
		url.searchParams.append("mapset", mapset);
		url.searchParams.append("attribution", "none");

		mapImg.src = url.toString();
		mapContainer.append(mapImg);

		// marker
		const marker = node("span");
		const markerImg = new Image();

		marker.classList.add("detail-map-marker");
		markerImg.classList.add("detail-map-marker-img");
		markerImg.crossOrigin = "anonymous";
		markerImg.src = `${API_URL}/img/api/wmmarker/universal.png`;
		marker.append(markerImg);
		mapContainer.append(marker);

		this._promiseData.resolve([mapContainer, "map"]);
	}
}
